// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"bbafb9ec","253":"04e542b7","328":"01357ed6","503":"34a91696","744":"34a91696","957":"34a91696"}[chunkId] + ".chunk.css";
};